import React from "react"
import PropTypes from "prop-types"
import { useNavigate, useSearchParams } from "react-router-dom"
import { routes } from "router"
import classNames from "classnames"
import moment from "moment"
import { Text } from "ui/Typography"
import { colors } from "themes/variables"
import { useDispatch, useSelector } from "react-redux"
import { clearEditingMessage, createConversation } from "store/conversations"
import { List } from "antd"
import { Avatar } from "ui/Avatar"
import styles from "./Conversation.module.css"

export const Conversation = ({ conversation }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const role = useSelector((state) => state.user.role)
  const active = Number(searchParams?.get("conversation_id")) === conversation?.id
  const isGuide = role === "guide_user"
  const url = isGuide
    ? routes.proMessagesRootPath({}, { conversation_id: conversation.id })
    : routes.clientMessagesPath({}, { conversation_id: conversation.id })
  const participant = isGuide ? conversation.client : conversation.contact
  const lastMessage = conversation.last_message
  const slicedMessage = lastMessage?.body ? lastMessage?.body?.slice(0, 100) : lastMessage?.media_url ? "File Attachment" : ""
  const isSlicedMessage = conversation.last_message?.body?.length > slicedMessage?.length

  const formattedTime = conversation.updated_message_at
    ? moment.utc(conversation?.updated_message_at).local().calendar(null, {
        sameDay: "hh:mm A", // Today
        lastDay: "[Yesterday] hh:mm A", // Yesterday
        sameElse: "MMMM D hh:mm A" // Earlier dates
      })
    : "No timestamp available"

  const onConversationClick = () => {
    if (!conversation?.id) {
      dispatch(createConversation({ participant_id: isGuide ? conversation.client_id : conversation.contact_id })).then((conversation) =>
        navigate(routes.proMessagesRootPath({}, { conversation_id: conversation.id }))
      )
    }
    dispatch(clearEditingMessage())
    navigate(url)
  }

  return (
    <List.Item
      className={classNames(styles.conversation, !isGuide && styles.leftContainer)}
      onClick={onConversationClick}
      style={{ backgroundColor: active ? colors.disabled : "" }}
    >
      <List.Item.Meta
        avatar={<Avatar size={60} src={participant?.avatar} fullName={participant?.full_name} />}
        title={
          <div className="justify-between align-center">
            <Text variant="sub" size="lg">
              {participant?.full_name}
            </Text>
            <Text variant="caption" type="secondary">
              {formattedTime}
            </Text>
          </div>
        }
        description={
          <div className="justify-between">
            <Text variant="body" type="secondary">
              {slicedMessage}
              {isSlicedMessage && "..."}
            </Text>
            {conversation?.unviewed > 0 && <div className={styles.unviewed}>{conversation?.unviewed}</div>}
          </div>
        }
      />
    </List.Item>
  )
}

// Add PropTypes validation
Conversation.propTypes = {
  conversation: PropTypes.shape({
    id: PropTypes.number.isRequired,
    contact: PropTypes.shape({
      avatar: PropTypes.string,
      full_name: PropTypes.string
    }),
    client: PropTypes.shape({
      avatar: PropTypes.string,
      full_name: PropTypes.string
    }),
    last_message: PropTypes.shape({
      body: PropTypes.string
    }),
    updated_message_at: PropTypes.string,
    unviewed: PropTypes.number
  }).isRequired
}
